import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { AccountActions } from './account.actions';

@Injectable({
  providedIn: 'root'
})
export class AccountEffects {
  sendAccountEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendAccountEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(AccountActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
